/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2021-01-05
13:08:14 * @modify date 2021-01-05 13:08:14 * @desc [description] */
<template>
  <div class="content-wrappper">
    <div class="row m-0 manager-container">
      <div class="row mb-25 mt-25 ml-15 mr-15">
        <div class="col-lg-8 col-md-7 col-sm-6 col-xs-12">
          <router-link class="sub-heading" to="/layout/launchpad">
            <i class="fa fa-angle-left"></i>Project Manager Team Access
          </router-link>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-6 col-xs-12 xs-mt-20">
          <search-box v-model="searchText" @getList="getListBySearchName"></search-box>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xs-12 p-0">
          <div class="first_table">
            <table class="table activity-tracker-table">
              <thead>
                <tr>
                  <th class="filter-th wd-65 sticky"></th>
                  <th
                    class="wd-65 shadow_col sticky-checkbox"
                  >
                    <span class="checkbox" v-if="filteredList && filteredList.length">
                      <label>
                        <input
                          type="checkbox"
                          v-model="selectAllManagers"
                          :disabled="filteredList.length < 2"
                          @change="selectAll()"
                        />
                        <span class="cr"></span>
                      </label>
                    </span>
                  </th>
                  <th v-for="header in headers" :key="header.key">
                    {{ header.name
                    }}<span
                      class="sort"
                      @click="sortBy(header.key)"
                      :class="sortOrders[header.key] > 0 ? 'asc' : 'desc'"
                      ><img src="/static/images/icons/sortDesc.svg"
                    /></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(projectManager,index) in filteredList" :key="index">
                  <td class="menu-td sticky">
                    <div
                      :id="'trackerActionDots' + index"
                      class="dropdown dropdown-export export-activity-menu text-center"
                    >
                      <div
                        data-toggle="dropdown"
                        @click="menuDropdown"
                        style="margin-top: 1px"
                      >
                        <span class="dropdown-toggle">
                          <i class="fa fa-ellipsis-v menu-dots"></i>
                        </span>
                      </div>
                      <ul
                        class="activitytrackermenu dropdown-menu export-menu"
                        v-bind:class="changeClass ? 'addReverse' : ''"
                      >
                        <el-tooltip
                                  class="item"
                                  effect="light"
                                  content="Admin users cannot be converted as REP PM."
                                  placement="top-start"
                                  :disabled="!projectManager.is_admin"
                                >
                        <li @click="projectManager.is_admin ? null: openConvertPMtoREP(projectManager)">
                          <a class="text-color-blue menu-dots-links" :disabled="projectManager.is_admin">
                            <img
                              src="/static/images/icons/convertion_icon.svg"
                              class="tracker-images"
                              alt="convertion-icon"
                            />
                            <span>Convert to REP PM</span>
                          </a>
                        </li>
                        </el-tooltip>
                        <li class="divider"></li>
                        <li @click="openDeletePopup(true, projectManager.user_account_id)">
                          <a class="text-color-delete-red menu-dots-links">
                            <img
                              src="/static/images/icons/delete_icon.svg"
                              class="tracker-images"
                              alt="delete-icon"
                            />
                            <span>Remove</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td class="sticky-checkbox">
                    <span class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          :value="projectManager.user_account_id"
                          v-model="selectedManager"
                        />
                        <span class="cr"></span>
                      </label>
                    </span>
                  </td>
                  <td
                    class="table-name"
                    v-for="header in headers"
                    :key="header.key"
                  >
                    <span class="table-accountname cursor-pointer decoration-underline"
                    v-if="header.key === 'company_name'" 
                     @click="openAccountDetails(projectManager.account_id)">{{ projectManager[header.key] }}</span>
                    <template v-else>{{ projectManager[header.key] }}</template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 class="center" v-if="filteredList && !filteredList.length">
            No Project Manager(s) found
          </h2>
        </div>
      </div>
      <div class="row ml-15 mr-0 mt-35 mb-20">
        <div
          class="col-xs-12 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3"
        >
          <button
            type="button"
            class="btn btn-block emergo-blue-button"
            :disabled="disableButtonForAddTeam || loaderStatus || selectedManager.length < 2"
            @click="openDeletePopup(false)"
            v-if="filteredList && filteredList.length"
          >Remove Project Manager(s)</button>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <convert-pm-to-rep-pm-popup
      @converted="getManagersList"
      :convertUserDetails="convertUserDetails"
    ></convert-pm-to-rep-pm-popup>
    <common-delete-user-popup
      :convertUserDetails="convertUserDetails"
      @deleteConfirmation="removeManager()"
    ></common-delete-user-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import { cloneDeep } from 'lodash';
import { Tooltip } from 'element-ui';
import Loader from '../UIComponents/Loader.vue';
import {
  getProjectManagersList,
  removeProjectManager,
} from '../../apis/submissionBuilder';
import SearchBox from '../UIComponents/SearchBox.vue';
import ConvertPmToRepPmPopup from './ConvertPmToRepPmPopup.vue';
import CommonDeleteUserPopup from '../Common/CommonDeleteUserPopup.vue';

export default {
  data() {
    return {
      loaderStatus: false,
      selectAllManagers: false,
      selectedManager: [],
      projectManagersList: null,
      filteredList: null,
      isPreviouslySearched: false,
      searchText: '',
      sortOrders: {},
      convertUserDetails: {},
      changeClass: false,
      sortKey: 'company_name',
      deleteUserStatus: null,
      headers: [
        {
          name: 'Account Name',
          key: 'company_name'
        },
        {
          name: 'First Name',
          key: 'first_name'
        },
        {
          name: 'Last Name',
          key: 'last_name'
        },
        {
          name: 'Email Id',
          key: 'email'
        },
        {
          name: 'Account Id',
          key: 'account_id'
        },
      ]
    };
  },
  components: {
    Loader,
    SearchBox,
    ConvertPmToRepPmPopup,
    'el-tooltip': Tooltip,
    CommonDeleteUserPopup
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    openAccountDetails(accountId) {
      sessionStorage.setItem('getPreviousUrl', window.location.pathname);
      sessionStorage.setItem('getAccountDetailsId', accountId);
      this.$router.push('/layout/accountdetails');
    },
    sortBy(sortKey) {
      this.sortOrders[sortKey] = !this.sortOrders[sortKey];
      this.filteredList.sort((item1, item2) => {
        const x = item1[sortKey] && typeof item1[sortKey] === 'number' ? item1[sortKey] : (item1[sortKey].toLowerCase() || '');
        const y = item2[sortKey] && typeof item2[sortKey] === 'number' ? item2[sortKey] : (item2[sortKey].toLowerCase() || '');
        if (x < y) {
          return this.sortOrders[sortKey] ? -1 : 1;
        }
        if (x > y) {
          return this.sortOrders[sortKey] ? 1 : -1;
        }
        return 0;
      });
    },
    selectAll() {
      if (this.selectAllManagers) {
        this.selectedManager = this.filteredList.map(
          (projectManager) => projectManager.user_account_id,
        );
      } else {
        this.selectedManager = [];
      }
    },
    async getManagersList() {
      this.convertUserDetails = {};
      this.loaderStatus = true;
      this.projectManagersList = await getProjectManagersList();
      this.filteredList = cloneDeep(this.projectManagersList);
      if(this.searchText) this.getListBySearchName();
      this.loaderStatus = false;
    },
    openDeletePopup(single = false, selectedUserId) {
      this.deleteUserStatus = single ? selectedUserId: null;
      $('#basic_delete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async removeManager() {
      this.loaderStatus = true;
      const response = await removeProjectManager(this.deleteUserStatus ? [this.deleteUserStatus] : this.selectedManager);
      this.loaderStatus = false;
      if (response && response.status === 'Success') {
        this.selectAllManagers = false;
        this.deleteUserStatus = null;
        this.selectAll();
        await this.getManagersList();
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: response.message,
          group: 'custom-notification'
        });
      } else if (response && response.status === 'Failed') {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: response.message,
          group: 'custom-notification'
        });
      }
    },
    // To Disable modal on select of tracker dots
    menuDropdown(event) {
      $('td.sticky').css('z-index', 0);
      $(event.target).closest('td.sticky').css('z-index', 1);
      this.dropDownMenuDisable = true;
      this.changeClass = false;
      if (event.screenY > window.innerHeight - 90) {
        this.changeClass = true;
      } else {
        this.changeClass = false;
      }
    },
    async openConvertPMtoREP(selectedUser) {
      this.convertUserDetails = cloneDeep(selectedUser);
      $('#convertPMtoREP').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    getListBySearchName() {
      if (this.searchText) {
        this.searchText
          .toLowerCase()
          .split(' ')
          .forEach((search) => {
            this.filteredList = this.projectManagersList.filter((row) =>
              Object.keys(row).some((key) => {
                return key !== 'user_account_id' 
                      && key !== 'is_admin'
                      && key !== 'user_id'
                      && String(row[key]).toLowerCase().indexOf(search) > -1;
              })
            );
          });
      this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filteredList = cloneDeep(this.projectManagersList);
        this.isPreviouslySearched = false;
      }
       if (this.selectedManager.length === this.filteredList.length) {
        this.selectAllManagers = true;
      } else {
        this.selectAllManagers = false;
      }
    },
  },
  watch: {
    selectedManager() {
      if (this.selectedManager.length === this.filteredList.length) {
        this.selectAllManagers = true;
      } else {
        this.selectAllManagers = false;
      }
    }
  },
  computed: {
    disableButtonForAddTeam() {
      if (this.selectedManager.length > 0) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.getManagersList();
  }
};
</script>
<style lang="scss" scoped>
.manager-container {
  .sub-heading {
    i {
      margin-right: 6px;
    }
    font-family: $font-family-roboto;
    font-size: 18px;
    color: #0b3c61;
    cursor: pointer;
  }
  .sort {
    padding-left: 8px;
    &.asc {
      img {
        -ms-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }
  }
  .activity-tracker-table {
    .dropdown-menu.export-menu::after {
      left: -25px;
    }
  }
}
@media screen and (max-width: 767px) {
  .activity-tracker-table.table {
    tr {
      .sticky-checkbox::before {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: 3px 3px 4px $black-alpha1;
        display: block;
        top: 0px;
        z-index: -1;
      }
    }
  }
  .xs-mt-20 {
    margin-top: 20px;
  }
}
</style>
